import { useEffect, useMemo, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { toggleGlobalSearchModal_action } from 'store/actions'
import { GlobalSearchModalStyled, RecentSearches, SearchItems, SearchResults } from 'modules/app/styles'
import { Input, ModalBody } from 'reactstrap'
import { ReactComponent as SearchIcon } from 'assets/images/icons/search24.svg'
import { CustomButton } from 'modules/auth/styles'
import SearchItem from './SearchItem'
import { getContents_api } from 'store/apis'
import { PageLoader } from 'utils/storageUtils'
import { consoleLog } from 'utils/helpers'

let searchTimeout = null
const GlobalSearchModal = (props) => {
  const { showGlobalSearchModal } = props
  const [recentSearches, set_recentSearches] = useState([])
  const [selectedFilter, set_selectedFilter] = useState('all')
  const [searchText, set_searchText] = useState('')
  const [isLoading, set_isLoading] = useState(false)

  const searchInputElem = useRef(null)
  useEffect(() => {
    if (showGlobalSearchModal) {
      setTimeout(() => {
        if (searchInputElem && searchInputElem.current) searchInputElem.current.focus()
      }, 200)
    }
  }, [searchInputElem, showGlobalSearchModal])

  // Search
  const searchData = async (search) => {
    if (search) {
      try {
        set_isLoading(true)
        const contents = await getContents_api({ search, with_drafts: true })
        set_recentSearches(contents || [])
      } catch (error) {
        consoleLog(error)
      }
      set_isLoading(false)
    }
  }

  useEffect(() => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => searchData(searchText), 500)
  }, [searchText])

  const filteredRecentSearches = useMemo(() => {
    if (selectedFilter === 'all') {
      return recentSearches || []
    } else {
      const filtered = recentSearches.filter((item) => item.type === selectedFilter)
      return filtered || []
    }
  }, [selectedFilter, recentSearches])

  return (
    <GlobalSearchModalStyled isOpen={props.showGlobalSearchModal} fade={false} toggle={() => props.toggleGlobalSearchModal(false)} style={{ borderRadius: 4 }}>
      <ModalBody>
        <div className='search-box'>
          <SearchIcon />
          <Input placeholder='Search all files' name='searchInputElem' value={searchText} innerRef={searchInputElem} onChange={(e) => set_searchText(e.target.value)} />
        </div>

        {!!recentSearches.length && (
          <SearchResults>
            <div className='filterButtons'>
              <CustomButton onClick={() => set_selectedFilter('all')} className={`${selectedFilter === 'all' ? 'blue' : 'outlined gray'} btn-sm shadow-none`}>
                All results
              </CustomButton>
              <CustomButton onClick={() => set_selectedFilter('page')} className={`${selectedFilter === 'page' ? 'blue' : 'outlined gray'} btn-sm shadow-none`}>
                Pages
              </CustomButton>
              <CustomButton onClick={() => set_selectedFilter('response')} className={`${selectedFilter === 'response' ? 'blue' : 'outlined gray'} btn-sm shadow-none`}>
                Responses
              </CustomButton>
            </div>
          </SearchResults>
        )}

        <RecentSearches>
          {isLoading && (
            <div className='d-flex justify-content-center'>
              <PageLoader />
            </div>
          )}
          {!isLoading && !searchText && <div className='label'>Recent Pages & Responses</div>}
          {!isLoading && searchText && filteredRecentSearches.length === 0 && <div className='text-center p-5'>NO RESULTS FOUND</div>}
          <SearchItems className='recent-search-items'>
            {filteredRecentSearches.map((content, i) => (
              <SearchItem
                isOnGracePeriod={props.isOnGracePeriod}
                toggleGlobalSearchModal={props.toggleGlobalSearchModal}
                isFree={props.isFree}
                is_subscribed={props.is_subscribed}
                content={content}
                key={i}
                index={i}
                searchText={searchText}
              />
            ))}
          </SearchItems>
        </RecentSearches>
      </ModalBody>
    </GlobalSearchModalStyled>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isFree: state.company.company.isFree,
  is_subscribed: state.subscription.is_subscribed,
  showGlobalSearchModal: state.contents.showGlobalSearchModal
})

const mapDispatchToProps = (dispatch) => ({
  toggleGlobalSearchModal: (status) => dispatch(toggleGlobalSearchModal_action(status))
})

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearchModal)
